export const FETCH_START      = "HomeDesigns/FETCH_START"
export const FETCH_SUCCESS    = "HomeDesigns/FETCH_SUCCESS"
export const FETCH_FAILED     = "HomeDesigns/FETCH_FAILED"

export const FILTERS_UPDATED  = "HomeDesigns/FILTERS_UPDATED"
export const FILTERS_UPDATED_NO_REFRESH  = "HomeDesigns/FILTERS_UPDATED_NO_REFRESH"

export const FILTERS_RESET     = "HomeDesigns/FILTERS_RESET"
